import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  _theme => ({
    container: {
      height: 48,
      padding: "0 36px",
      backgroundColor: "#F4F8FF",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    countTextContainer: {
      color: "#0030FF"
    },
    buttonsContainer: {
      display: "flex",
      alignItems: "center"
    }
  }),
  { name: "SelectedCountComponent" }
);
